import { type RovoInstrumentedError } from '@atlassian/conversation-assistant-utils/httpUtils';

import { generateTraceId } from './generateTraceId';

/**
 * This error is specific to catch error while looping through the generator
 */
export class StreamGeneratorError extends Error implements RovoInstrumentedError {
	errorAttributes: RovoInstrumentedError['errorAttributes'];
	cause?: unknown;

	constructor(
		message: string,
		params: {
			detail?: {
				millisOffset?: number;
				type: string;
			};
			traceId: string | undefined;
		},
		cause?: unknown,
	) {
		super(message);
		this.name = this.constructor.name;
		this.cause = cause;
		this.errorAttributes = {
			traceId: params.traceId ?? `StreamGenerator-${generateTraceId()}`,
			latestStreamMessageType: params.detail?.type,
			latestStreamMessageMillisOffset: params.detail?.millisOffset,
		};
	}
}
